import React, { useState, useRef } from 'react';
import { useIntl } from 'react-intl';
import TabContent from './TabContent';
import { Tabs } from 'antd';
import ContentHeader from 'containers/Dashboard/ContentHeader';

const UserView = ({ match }) => {
  const { params } = match;
  const intl = useIntl();
  const [state, setState] = useState({
    activeTab: 0,
  });
  const userEditRef = useRef();
  const tabNames = [
    <>{intl.formatMessage({ id: 'User Profile' })}</>,
    <>{intl.formatMessage({ id: 'Phone history' })}</>,
  ];

  const handleTabClick = index => {
    tabNames.forEach((_, id) => id < index);
    setState(prev => ({ ...prev, activeTab: index }));
  };

  const callbackTabClicked = key => {
    handleTabClick(+key);
  };

  const handleCreateCustomer = () => {
    if (userEditRef.current?.checkCreateCustomer) {
      userEditRef.current.checkCreateCustomer();
    }
  };

  return (
    <div className="user_edit_layout">
      <ContentHeader type="user_edit" uid={params.id} onCreateCustomer={handleCreateCustomer} />
      <Tabs
        defaultActiveKey="0"
        tabPosition={'top'}
        onTabClick={callbackTabClicked}
        className="user_edit_tabs"
        activeKey={`${state.activeTab}`}
        items={tabNames.map((item, i) => {
          const id = String(i);
          return {
            label: item,
            key: id,
          };
        })}
      />
      <div className="tab_content">
        <TabContent index={state.activeTab} match={match} ref={userEditRef} />
      </div>
    </div>
  );
};

export default UserView;
